import { compact, filter, includes, map } from 'lodash'
import { PermissionData } from '../apis/permission.api'

export default {
  listNames (permissions: PermissionData[]) {
    const names = map(permissions, permission => {
      const { module: moduleData } = permission
      if (moduleData) return moduleData.name
    })
    return compact(names)
  },

  listIds (permissions: PermissionData[]) {
    return map(permissions, permission => permission.id)
  },

  filterByNames (
    permissions: PermissionData[],
    permissionNames: string[]
  ): PermissionData[] {
    return filter(permissions, permission => {
      if (!permission.module) return false
      return includes(permissionNames, permission.module.name)
    })
  }
}
